function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { PureComponent } from 'react';
import classNames from 'classnames';
import Button from '../../button/Button';
import { TABBABLE_INDEX, UNTABBABLE_INDEX } from '../../hotKeys/constants';
import { getTabId, getPanelId } from '../util';

var TabItem =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TabItem, _PureComponent);

  function TabItem() {
    _classCallCheck(this, TabItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(TabItem).apply(this, arguments));
  }

  _createClass(TabItem, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var wasSelected = prevProps.isSelected;
      var isSelected = this.props.isSelected;

      if (!wasSelected && isSelected) {
        this._selectedTab.focus();
      }
    }
  }, {
    key: "_getRef",
    value: function _getRef(ref) {
      this._selectedTab = ref;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          displayName = _this$props.displayName,
          onSelected = _this$props.onSelected,
          isSelected = _this$props.isSelected,
          isDisabled = _this$props.isDisabled;
      var tabItemClasses = classNames('eds-tabs__item', 'eds-l-pad-hor-2', 'eds-l-md-pad-hor-3', 'eds-l-mw-pad-hor-4', 'eds-l-ln-pad-hor-4', 'eds-l-lg-pad-hor-4', 'eds-l-lw-pad-hor-4', {
        'eds-tabs__item--selected': isSelected,
        'eds-tabs__item--disabled': isDisabled
      });
      var tabItemLinkClasses = classNames('eds-tabs__item-link', 'eds-l-pad-vert-3');
      var tabIndex = isSelected ? TABBABLE_INDEX : UNTABBABLE_INDEX;
      var controlledPanel;

      if (isSelected) {
        controlledPanel = getPanelId(value);
      }

      return React.createElement("li", {
        id: getTabId(value),
        className: tabItemClasses,
        role: "tab",
        "aria-selected": isSelected,
        "aria-controls": controlledPanel
      }, React.createElement(Button, {
        ref: this._getRef.bind(this),
        style: "none",
        __containerClassName: tabItemLinkClasses,
        onClick: onSelected,
        "data-spec": "tab-link--".concat(value),
        "data-automation": "tab-link--".concat(value),
        tabIndex: tabIndex,
        disabled: isDisabled
      }, React.createElement("span", {
        className: "eds-text-weight--heavy"
      }, displayName)));
    }
  }]);

  return TabItem;
}(PureComponent);

export { TabItem as default };